<!-- Translated: skip -->
<template>
  <div :class="{component: true, disabled: loading}">

    <h1 v-if="isNew">Skapa lösenord</h1>
    <h1 v-else>Återställ lösenord</h1>

    <div v-if="!loggedIn">

      <p>Ange ett nytt, säkert lösenord nedan (minst 6 tecken långt)</p>

      <Loading :show="loading" />
      <div>
        <label>Nytt lösenord</label>
        <input @keyup.enter="save()" placeholder="Nytt lösenord" type="password" v-model="user.new_password" />
      </div>
      <div class="center wide">
        <p class="error-message" v-if="errorMessage">{{errorMessage}}</p>
        <p class="success-message" v-if="successMessage">{{successMessage}}</p>
      </div>
      <div class="center wide">
        <button class="block" @click="save()">Spara</button>
      </div>

    </div>

    <div v-if="loggedIn">

      <p>Du är redan inloggad. <router-link :to="{name: 'my pages'}">Klicka här</router-link> om du vill gå till dina sidor.</p>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  data() {
    return {
      user: {
        new_password: '',
      },
      loading: false,
      errorMessage: '',
      successMessage: '',
    };
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    isNew() {
      return this.$route.name.match(/create/);
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'setUser',
    ]),
    async save() {
      this.loading = true;
      const { token, success, errorMessage } = await API.post('/account/reset-password', {
        token: this.$route.params.token,
        password: this.user.new_password,
      });

      if (!success) {
        this.errorMessage = errorMessage;
      } else {
        this.setUser({
          token,
        });
        this.$emit('login', success);

        this.$router.push({ name: 'my pages' });
      }

      this.loading = false;
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.component
  max-width 500px
  margin 0 auto
  display flex
  flex-wrap wrap
  justify-content space-between
  padding-top 60px
  centered()
  h1
    centered()
    margin-left auto
    margin-right auto
  & > div
    width 100%
    &.wide
      width 100%
  label
    font-size 11px
    margin-bottom 0
    text-align: left

.disabled
  disabled-grey()

input
  input()
  margin-bottom 20px
  max-width 100%
  min-width 10%

.error-message
  margin-top 10px
  margin-bottom 10px
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?26b0e37c